import { useState } from "react";
import { ChevronDown } from "lucide-react";

const SECTIONS = [
  {
    title: "1. Objeto",
    body: `La presente política regula las condiciones de devolución y cancelación de la inscripción al torneo PROXIMA LEAGUE, organizado el día 25 de octubre en Totem Sports Center (Tordera). Al formalizar la inscripción y abonar la cuota correspondiente, el equipo y su representante aceptan expresamente las condiciones aquí descritas.`,
  },
  {
    title: "2. Importe de la inscripción",
    body: `El importe de la inscripción es de 150 € por equipo. Este importe incluye los gastos organizativos, el arbitraje, el seguro de accidentes para todos los jugadores inscritos en acta, el uso de las instalaciones de Totem Sports Center (Tordera) durante la jornada oficial del torneo y el resto de servicios anunciados por la organización.`,
  },
  {
    title: "3. Derecho de desistimiento (14 días)",
    body: `De conformidad con la normativa aplicable (Ley 34/2002, de Servicios de la Sociedad de la Información y de Comercio Electrónico — LSSI — y la legislación de defensa de consumidores y usuarios), el representante del equipo dispone de un plazo de 14 días naturales desde la fecha de pago de la inscripción para ejercer su derecho de desistimiento, sin necesidad de justificación.

El ejercicio de este derecho dentro del plazo indicado dará lugar a la devolución íntegra del importe abonado. La solicitud deberá remitirse por escrito al canal oficial de contacto de PROXIMA LEAGUE (info@proximaleague.com o WhatsApp oficial), indicando el nombre del equipo y los datos del pago.

Si el torneo se celebrara dentro del citado plazo de 14 días y el equipo hubiera participado, se entenderá que el servicio ha sido prestado en su totalidad y no procederá el desistimiento.`,
  },
  {
    title: "4. Cancelación por parte del equipo participante",
    body: `Transcurrido el plazo de desistimiento, las cancelaciones de inscripción por parte del equipo se regirán según los siguientes plazos, contados respecto al inicio del torneo (25 de octubre):

• Cancelación con más de 30 días naturales de antelación: devolución del 80% del importe.
• Cancelación entre 15 y 30 días naturales: devolución del 50% del importe.
• Cancelación entre 7 y 14 días naturales: devolución del 25% del importe.
• Cancelación con menos de 7 días naturales: no procederá devolución alguna.

Las solicitudes deberán remitirse por escrito al canal oficial de contacto de PROXIMA LEAGUE y se considerarán efectivas en la fecha de recepción.`,
  },
  {
    title: "5. Cancelación o aplazamiento por parte de la organización",
    body: `En caso de que la organización se vea obligada a cancelar el torneo por causas que le sean directamente imputables, el equipo inscrito tendrá derecho a la devolución íntegra del importe abonado.

Si la cancelación o el aplazamiento se debiera a causas de fuerza mayor (condiciones meteorológicas adversas, decisiones administrativas, sanitarias, indisponibilidad sobrevenida de la sede, u otras circunstancias ajenas al control de la organización), PROXIMA LEAGUE podrá optar entre reprogramar el torneo manteniendo la inscripción ya abonada o devolver el 70% del importe, descontando los gastos no reembolsables ya incurridos.`,
  },
  {
    title: "6. No presentación o incomparecencia",
    body: `La no presentación del equipo al torneo, total o parcial, así como la incomparecencia a cualquiera de los partidos programados, no dará derecho a la devolución total o parcial del importe abonado. El equipo será considerado, a todos los efectos, como participante.`,
  },
  {
    title: "7. Expulsión disciplinaria",
    body: `En el caso de que un equipo o jugador sea expulsado del torneo por una infracción grave del reglamento, agresiones, comportamientos antideportivos o cualquier otra causa contemplada en el reglamento interno de PROXIMA LEAGUE, no procederá la devolución de la cuota de inscripción.`,
  },
  {
    title: "8. Forma y plazo de devolución",
    body: `Las devoluciones autorizadas se realizarán a través del mismo medio de pago utilizado para la inscripción, salvo acuerdo expreso en contrario, y dentro de un plazo máximo de 30 días naturales desde la aprobación de la solicitud.`,
  },
  {
    title: "9. Aceptación",
    body: `La inscripción en PROXIMA LEAGUE implica la aceptación íntegra de esta política, así como del resto del reglamento del torneo. Para cualquier conflicto derivado de su aplicación, las partes se someten a los tribunales competentes de la ciudad de Girona.`,
  },
];

const LegalPolicy = () => {
  const [open, setOpen] = useState(0);

  return (
    <section
      id="legal"
      data-testid="legal-section"
      className="relative bg-[#070707] py-24 sm:py-32 border-t border-white/5"
    >
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="text-xs tracking-[0.3em] uppercase text-[#EAB308] mb-4">
          Marco Legal
        </div>
        <h2 className="font-display text-4xl sm:text-5xl uppercase tracking-tight leading-none mb-4">
          Política de devoluciones
          <br />
          <span className="text-white/40">y cancelaciones</span>
        </h2>
        <p className="text-white/50 text-sm max-w-2xl mb-12 font-body">
          Documento contractual aplicable a todos los equipos inscritos en
          PROXIMA LEAGUE. Edición I — 2026.
        </p>

        <div className="border-t border-white/10">
          {SECTIONS.map((s, idx) => {
            const isOpen = open === idx;
            return (
              <div
                key={s.title}
                className="border-b border-white/10"
                data-testid={`legal-item-${idx}`}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : idx)}
                  className="w-full text-left py-6 flex items-center justify-between gap-6 group"
                  data-testid={`legal-toggle-${idx}`}
                >
                  <span className="font-heading text-base sm:text-lg text-white group-hover:text-[#EAB308] transition-colors uppercase tracking-wide">
                    {s.title}
                  </span>
                  <ChevronDown
                    className={`w-5 h-5 text-white/40 transition-transform duration-300 ${
                      isOpen ? "rotate-180 text-[#EAB308]" : ""
                    }`}
                    strokeWidth={1.5}
                  />
                </button>
                <div
                  className={`grid transition-all duration-500 ease-out ${
                    isOpen ? "grid-rows-[1fr] opacity-100 pb-8" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="text-white/65 font-body text-sm sm:text-base leading-relaxed whitespace-pre-line max-w-3xl">
                      {s.body}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default LegalPolicy;
